/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

document.addEventListener('DOMContentLoaded', function () {

  function createPopup() {
    if(!window.galvanizationPopupMessage) return;

    // Prevent duplicate popup
    if (document.querySelector('.gpo-popup-overlay')) return;

    const overlay = document.createElement('div');
    overlay.className = 'gpo-popup-overlay';

    const popup = document.createElement('div');
    popup.className = 'gpo-popup';

    const closeBtn = document.createElement('button');
    closeBtn.className = 'gpo-popup-close';
    closeBtn.innerHTML = '&times;';

    const content = document.createElement('div');
    content.className = 'gpo-popup-content';
    content.innerText = window.galvanizationPopupMessage || '';


    popup.appendChild(closeBtn);
    popup.appendChild(content);
    overlay.appendChild(popup);
    document.body.appendChild(overlay);

    // Close popup function
    function closePopup() {
      overlay.remove();
    }

    closeBtn.addEventListener('click', closePopup);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) {
        closePopup();
      }
    });
  }


  function initGalvanizationCheckbox() {

    const optionBlocks = document.querySelectorAll('.product-form__option');
    let galvanizationBlock = null;

    optionBlocks.forEach(block => {
      const label = block.querySelector('.product-form__option-name');
      if (!label) return;

      if (label.innerText.toLowerCase().includes('galvanization')) {
        galvanizationBlock = block;
      }
    });

    if (!galvanizationBlock) return;

    const swatchList = galvanizationBlock.querySelector('.block-swatch-list');
    if (!swatchList) return;

    const swatches = swatchList.querySelectorAll('.block-swatch');
    if (swatches.length !== 2) return;

    let nonGalvRadio = null;
    let galvRadio = null;

    swatches.forEach(swatch => {
      const radio = swatch.querySelector('input[type="radio"]');
      const text = swatch.querySelector('.block-swatch__item-text')?.innerText.trim().toLowerCase();

      if (!radio || !text) return;

      if (text.includes('non')) {
        nonGalvRadio = radio;
      } else {
        galvRadio = radio;
      }
    });

    if (!nonGalvRadio || !galvRadio) return;

    // Hide swatches permanently
    galvanizationBlock.classList.add('galvanization-option');
    swatchList.classList.add('galvanization-hide-swatches');


    // Prevent duplicate checkbox
    if (galvanizationBlock.querySelector('.galvanization-custom-wrapper')) return;

    const wrapper = document.createElement('div');
    wrapper.className = 'galvanization-custom-wrapper';

    const label = document.createElement('label');
    label.className = 'galvanization-checkbox-label';

    const checkbox = document.createElement('input');
    checkbox.type = 'checkbox';
    checkbox.className = 'galvanization-custom-checkbox';

    const span = document.createElement('span');
    span.className = 'galvanization-checkbox-text';
    span.innerText = 'Galvanization';

    label.appendChild(checkbox);
    label.appendChild(span);
    wrapper.appendChild(label);

    galvanizationBlock.insertBefore(wrapper, swatchList);

    checkbox.checked = galvRadio.checked;

    checkbox.addEventListener('change', function () {
      if (checkbox.checked) {
        galvRadio.click();
        createPopup();
      } else {
        nonGalvRadio.click();
      }
    });

    // Variant → Checkbox sync
    [nonGalvRadio, galvRadio].forEach(radio => {
      radio.addEventListener('change', function () {
        checkbox.checked = galvRadio.checked;
      });
    });
  }

  initGalvanizationCheckbox();

  const observer = new MutationObserver(function () {
    initGalvanizationCheckbox();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

});